import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    dialog: false,
    dialog_filter: false,
    loading: false,
    users: [],
    asset_labels: [],
    cid_users: [],
    user: {},
    order_column: 'name',
    order_type: 'asc',
    page: 1,
    page_size: 10,
    filter: {}
  },

  mutations: {
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setDialogFilter(state, payload) {
       state.dialog_filter = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setUsers(state, payload) {
      state.users = payload
    },
    setSelectedUser(state, payload) {
      state.user = payload
    },
    setCidUsers(state, payload) {
      state.cid_users = payload
    },
    setAssetLabels(state, payload) {
      state.asset_labels = payload
    },
    setClientAssetLabels(state, payload) {
      state.user.clients = payload
    },
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/user', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setUsers',r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
          .post('cms/youtube/user', {
              user_id: state.user.user_id,
              name: state.user.name,
              email: state.user.email,
              active: state.user.active,
              asset_label_id: state.user.asset_label_id,
              clients: state.user.clients
          })
          .then(() => {
            commit('setDialog', false)
            commit('setSelectedUser', {})
            dispatch('read')
          })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
          .put('cms/youtube/user/' + id, {
            user_id: state.user.user_id,
            name: state.user.name,
            email: state.user.email,
            active: state.user.active,
            asset_label_id: state.user.asset_label_id,
            clients: state.user.clients
          })
          .then(() => {
            commit('setDialog', false)
            commit('setSelectedUser', {})
            dispatch('read')
          })
    },
    readCidUsers({ state, commit }) {
          commit('setLoading', true)
          axios.admin
              .get('cms/youtube/user/service/1')
              .then(r => {
                  commit('setCidUsers', r.data.data)
                  commit('setLoading', false)
              })
              .catch(() => {
                  commit('setLoading', false)
              })
    },
    readAssetLabels({ state, commit }) {
          commit('setLoading', true)
          axios.admin
              .get('cms/youtube/user/assetlabel')
              .then(r => {
                  commit('setAssetLabels', r.data.data)
                  commit('setLoading', false)
              })
              .catch(() => {
                  commit('setLoading', false)
              })
    }
  }
}
